import { config } from "@repo/config";

/**
 * Link previews and search results. Absolute URLs on the production origin:
 * crawlers resolve nothing relative, and a canonical must name one host.
 */
export const siteOrigin = `https://${config.appDomain}`;

/** Search snippet and share text for the home page. */
export const siteDescription =
	"The AI shopping assistant for supermarkets in Saudi Arabia and the UAE. Shoppers ask in Arabic or English, in your app, on WhatsApp or by phone, and it fills their basket.";

/** 1200x630, the home page's card, rendered by apps/web/brand/og-cards.mjs (brand/render.sh). */
export const siteShareCard = {
	url: `${siteOrigin}/og.png`,
	width: 1200,
	height: 630,
	alt: "Hephon Commerce: a shopper asks for chicken shawarma for four and the assistant adds three products to the basket.",
};

/** A page's own link-preview card. */
export interface ShareCard {
	url: string;
	alt: string;
}

/**
 * Title, description, canonical and their Open Graph and X copies for one public page. A page
 * with its own card (`image`) replaces the root's default share image; the card type comes from
 * the root route.
 */
export function pageHead({
	title,
	description,
	path,
	image,
}: {
	title: string;
	description: string;
	path: string;
	image?: ShareCard;
}) {
	const url = `${siteOrigin}${path}`;
	return {
		meta: [
			{ title },
			{ name: "description", content: description },
			{ property: "og:title", content: title },
			{ property: "og:description", content: description },
			{ property: "og:url", content: url },
			{ name: "twitter:title", content: title },
			{ name: "twitter:description", content: description },
			...(image
				? [
						{ property: "og:image", content: image.url },
						{ property: "og:image:type", content: "image/png" },
						{
							property: "og:image:width",
							content: String(siteShareCard.width),
						},
						{
							property: "og:image:height",
							content: String(siteShareCard.height),
						},
						{ property: "og:image:alt", content: image.alt },
						{ name: "twitter:image", content: image.url },
						{ name: "twitter:image:alt", content: image.alt },
					]
				: []),
		],
		links: [{ rel: "canonical", href: url }],
	};
}
